export const DOCUMENT_LISTING_EVENTS = Object.freeze({
  checkSelected: 'documentListing:checkSelected',
  removeSelected: 'documentListing:removeSelected',
  selectAll: 'documentListing:selectAll',
  updateItem: 'documentListing:updateItem',
  updateCart: 'documentListing:updateCart'
});

export const NUMBER_OF_RESULTS = '{{number}}';

export const DOCUMENT_LINKS_STORAGE_KEY = 'documentLinks';

export const PERSONA_COOKIE = {
  commercial : 'commercial',
  residential: 'residential'
}
